import React from "react"
import { Container, VStack, Text } from "@chakra-ui/react"

export default function Caveat() {
  return (
    <Container alignItems="center" mt={14}>
      <VStack>
        <Text w="full" textAlign="center">
          All Prices are inclusive of VAT.
        </Text>
        <Text w="full" textAlign="center">
          Payment is due on receipt of each project. 30% deposit is required
          upon instruction of work.
        </Text>
      </VStack>
    </Container>
  )
}
